import { render } from "./MainWorkSlider.vue?vue&type=template&id=90f4462c&scoped=true"
import script from "./MainWorkSlider.vue?vue&type=script&lang=js"
export * from "./MainWorkSlider.vue?vue&type=script&lang=js"

import "./MainWorkSlider.vue?vue&type=style&index=0&id=90f4462c&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f4462c"]])

export default __exports__